<template>
  <button
    @click="refreshPage"
    class="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors duration-200"
    title="Refresh Page"
  >
    <RefreshCw
      :class="{ 'animate-spin': isRefreshing }"
      class="w-4 h-4 sm:w-5 sm:h-5"
    />
  </button>
</template>

<script>
  import { RefreshCw } from "lucide-vue-next";

  export default {
    name: "RefreshButton",
    components: {
      RefreshCw,
    },
    data() {
      return {
        isRefreshing: false,
      };
    },
    methods: {
      refreshPage() {
        this.isRefreshing = true;
        // Add a small delay to allow the animation to start before the page reloads
        setTimeout(() => {
          window.location.reload();
        }, 300); // Adjust delay as needed
      },
    },
  };
</script>

<style scoped>
  button:focus {
    outline: none;
  }
</style>
